import { tracking } from '@iwoca/frontend-tracking-library';
import { IconPhoneFilled } from '@iwoca/icons';
import { Button } from '@iwoca/orion';

import { isGiveUsACallVisible } from './visible';
import {
  iwocapayTelDisplay,
  iwocapayTelLink,
} from '../../../../../src/constants.json';
import { useGetFundingRequirement } from '../../../../api/lending/lapiHooks';
import { useOnMount } from '../../../../hooks/useOnMount';
import logger from '../../../../utils/logger';
import { Card } from '../../../components/Card/Card';
import { WhiteLabelOverride } from '../../../components/WhiteLabelOverride/WhiteLabelOverride';
import { useNavigateToNextRequirement } from '../../hooks/useNavigateToNextRequirement';

export const GiveUsACall = () => {
  const { goToNextRequirement } = useNavigateToNextRequirement();
  const { fundingRequirement } = useGetFundingRequirement();

  useOnMount(() => {
    if (isGiveUsACallVisible({ fundingRequirement: fundingRequirement! })) {
      logger.warn('Give us a call shown to user', {
        funding_requirements: fundingRequirement!,
      });
      return;
    }

    goToNextRequirement();
  });

  const trackGiveUsACallClicked = () => {
    tracking.ampli.buyerClickedGiveUsACallCta();
    return true;
  };

  return (
    <Card title="One last thing - give us a quick call">
      <WhiteLabelOverride componentType="button" disabled={false}>
        <Button
          className="my-s"
          type="primary"
          href={iwocapayTelLink}
          onClick={trackGiveUsACallClicked}
        >
          <IconPhoneFilled color="white" className="ml-xs" />
          {iwocapayTelDisplay}
        </Button>
      </WhiteLabelOverride>
      <p className="mb-0 text-m font-reg">
        Call your account manager to finish the last step.
      </p>
    </Card>
  );
};
